<template lang="pug">

  .flex.justify-center
    .pb-48.z-300.w-full.max-w-1366.flex
      .left-side.flex.flex-col.select-none
        .overflow-hidden.w-222.h-60.rounded-30.shadow-card.bg-white.flex.items-center.cursor-pointer.ml-28.mt-6.group(
          class="hover:bg-main-deep hover:text-white"
          @click="goCreate()"
          )
            .w-48.h-48.rounded-50.bg-main-0.ml-6.mr-30.flex.justify-center.items-center.rotate-45.transform(class="group-hover:bg-main-deep group-hover:ease-in-out")
              iCon.h-28.text-white(:iconClass="'close'" type="svg" )
            .text-20.leading-20.-ml-30.w-full {{$t('__c6N3.__createNew')}}
        SideMenuBlock(:sideOptions="sideOptions" :active="activeRoute" :activeRoute="currentRoute.path")
      .right-side.card.w-full.bg-white.mr-54
        router-view
  
</template>

<script>
// import { querySuggest } from "@/api/models.js"; //.absolute.left-60

// import moment from 'moment';
// import { mapMutations, mapGetters } from 'vuex';

import { PAGEINDEX } from "@/enum/global";
import SideMenuBlock from "@/components/SideMenuBlock.vue";
// import { npsSetting } from '@/utils/globe';

export default {
  name: "Index",
  components: {
    SideMenuBlock
  },
  data() {
    return {
      apiError: null //個別頁面的api error handler
    };
  },
  // mixins: [ npsSetting],
  async created() {},
  async mounted() {},
  methods: {
    goCreate() {
      this.$router
        .push({
          path: `/createnew`,
          query: {
            // type: '',
          }
        })
        .catch(err => err);
      this.$store.commit("common/setGoIndexRefresh", false);
    }

    // ...mapMutations({
    // setSinglePageAlert: 'modal/setSinglePageAlert',  // show modal
    // }),
  },
  watch: {
    $route: function(n, o) {}
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    activeRoute() {
      switch (this.currentRoute.name) {
        case PAGEINDEX.EXPORTHISTORY:
          return 0;
        case PAGEINDEX.DOWNLOAD:
          return 1;

        case PAGEINDEX.CREATE:
          return null;
      }
    },
    currentRoute() {
      return this.$route;
    },
    sideOptions() {
      return [
        {
          name: this.$t("__e5H7.__exportHistory"),
          val: "",
          disabled: false,
          icon: "Ico_Update History",
          twoLine: false
        },
        {
          name: this.$t("__d8.__applicationDownload"),
          val: PAGEINDEX.DOWNLOAD,
          disabled: false,
          icon: "Ico_App",
          twoLine: true
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.leftEachCol {
  &:hover {
    :first-child {
      @apply bg-main-0;
    }
  }
}
</style>
